import * as designTokens from '@calm/evexia-design-tokens';
import { CSSProperties } from 'react';

const typographyVariants: Record<string, CSSProperties> = {
    h1: {
        fontSize: designTokens.DS_FONT_SIZE.H1,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L_2,
    },
    h2: {
        fontSize: designTokens.DS_FONT_SIZE.H2,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L_1,
    },
    h3: {
        fontSize: designTokens.DS_FONT_SIZE.H3,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L0,
    },
    h4: {
        fontSize: designTokens.DS_FONT_SIZE.H4,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L4,
    },
    h5: {
        fontSize: designTokens.DS_FONT_SIZE.H5,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L0,
    },
    h6: {
        fontSize: designTokens.DS_FONT_SIZE.H6,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    subtitle1: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_LARGE,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
        lineHeight: 1.5,
    },
    subtitle2: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_SMALL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L1,
    },
    body1: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_MEDIUM,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    body2: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_SMALL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    // Same as Button Medium
    button: {
        fontSize: designTokens.DS_FONT_SIZE.BUTTON_MEDIUM,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L5,
    },
    caption: {
        fontSize: designTokens.DS_FONT_SIZE.LABEL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L5,
    },
    overline: {
        fontSize: designTokens.DS_FONT_SIZE.LABEL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'uppercase',
        letterSpacing: designTokens.DS_LETTER_SPACING.L7,
    },

    /* Non-standard variants */
    body1Demi: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_MEDIUM,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    buttonLarge: {
        fontSize: designTokens.DS_FONT_SIZE.BUTTON_LARGE,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L6,
    },
    buttonSmall: {
        fontSize: designTokens.DS_FONT_SIZE.BUTTON_SMALL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.DEMI,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L6,
    },
    avatarLetter: {
        fontSize: designTokens.DS_FONT_SIZE.AVATAR,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L2,
    },
    inputLabel: {
        fontSize: designTokens.DS_FONT_SIZE.LABEL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    inputText: {
        fontSize: designTokens.DS_FONT_SIZE.NORMAL_MEDIUM,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L3,
    },
    helperText: {
        fontSize: designTokens.DS_FONT_SIZE.LABEL,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.REGULAR,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L5,
    },
    tooltip: {
        fontSize: designTokens.DS_FONT_SIZE.TOOLTIP,
        fontFamily: designTokens.DS_FONT_FAMILY,
        fontWeight: designTokens.DS_FONT_WEIGHT.MEDIUM,
        fontStyle: 'normal',
        textTransform: 'none',
        letterSpacing: designTokens.DS_LETTER_SPACING.L0,
    },
    srOnly: {
        height: '1px',
        width: '1px',
        overflow: 'hidden',
        position: 'absolute',
    },
};

export default typographyVariants;
